// plugins/theme.client.ts
export default defineNuxtPlugin((nuxtApp) => {
  const defaultTheme = 'light' // 기본 테마 설정

  const setTheme = (theme: string) => {
    document.documentElement.setAttribute('data-theme', theme)
  }

  // 초기 테마 설정
  setTheme(defaultTheme)

  // 전역에서 사용할 수 있도록 provide 해줌
  nuxtApp.provide('setTheme', setTheme)
})